import { createRoot } from "react-dom/client";
import "./index.css";
import PickBuildSection from "./App.jsx";

function initPickBuildSection() {
  const container = document.getElementById("pick-build-root");
  if (container) {
    const root = createRoot(container);
    root.render(<PickBuildSection />);
  } else {
    console.warn("Pick Build section container #pick-build-root not found");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPickBuildSection);
} else {
  initPickBuildSection();
}
